import { render, staticRenderFns } from "./PostedBy.vue?vue&type=template&id=fc35b276&scoped=true&"
import script from "./PostedBy.vue?vue&type=script&lang=js&"
export * from "./PostedBy.vue?vue&type=script&lang=js&"
import style0 from "./PostedBy.vue?vue&type=style&index=0&id=fc35b276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc35b276",
  null
  
)

export default component.exports